/**
 * Generated by orval v7.7.0 🍺
 * Do not edit manually.
 * RakeBack Wizard API
 * OpenAPI spec version: 1.0.0
 */
import { useMutation } from '@tanstack/react-query'
import type { MutationFunction, UseMutationOptions, UseMutationResult } from '@tanstack/react-query'

import type { UserFeedbackCreate } from '../models'

import feedbackSubmitCreateMutator from '../../client'

/**
 * API view for creating user feedback.
Requires authentication.
The user is automatically set from the request.
PokerSite is identified by its slug in the request data.
 */
export const feedbackSubmitCreate = (
  userFeedbackCreate: UserFeedbackCreate,
  signal?: AbortSignal,
) => {
  return feedbackSubmitCreateMutator<UserFeedbackCreate>({
    url: `/api/v1/feedback/submit/`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: userFeedbackCreate,
    signal,
  })
}

export const getFeedbackSubmitCreateMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof feedbackSubmitCreate>>,
    TError,
    { data: UserFeedbackCreate },
    TContext
  >
}): UseMutationOptions<
  Awaited<ReturnType<typeof feedbackSubmitCreate>>,
  TError,
  { data: UserFeedbackCreate },
  TContext
> => {
  const mutationKey = ['feedbackSubmitCreate']
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof feedbackSubmitCreate>>,
    { data: UserFeedbackCreate }
  > = (props) => {
    const { data } = props ?? {}

    return feedbackSubmitCreate(data)
  }

  return { mutationFn, ...mutationOptions }
}

export type FeedbackSubmitCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof feedbackSubmitCreate>>
>
export type FeedbackSubmitCreateMutationBody = UserFeedbackCreate
export type FeedbackSubmitCreateMutationError = unknown

export const useFeedbackSubmitCreate = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof feedbackSubmitCreate>>,
    TError,
    { data: UserFeedbackCreate },
    TContext
  >
}): UseMutationResult<
  Awaited<ReturnType<typeof feedbackSubmitCreate>>,
  TError,
  { data: UserFeedbackCreate },
  TContext
> => {
  const mutationOptions = getFeedbackSubmitCreateMutationOptions(options)

  return useMutation(mutationOptions)
}
